/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import LabTestGroupItem from './lab-test-group-item';
import LabTestGroupItemDetail from './lab-test-group-item-detail';
import LabTestGroupItemUpdate from './lab-test-group-item-update';
import LabTestGroupItemDeleteDialog from './lab-test-group-item-delete-dialog';

const LabTestGroupItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<LabTestGroupItem />} />
    <Route path="new" element={<LabTestGroupItemUpdate />} />
    <Route path=":id">
      <Route index element={<LabTestGroupItemDetail />} />
      <Route path="edit" element={<LabTestGroupItemUpdate />} />
      <Route path="delete" element={<LabTestGroupItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default LabTestGroupItemRoutes;
